// extracted by mini-css-extract-plugin
export var loader__container = "loader-module--loader__container--0hXzr";
export var loader__message = "loader-module--loader__message--e+TQx";
export var loader__spinner = "loader-module--loader__spinner--NkVvI";
export var spin = "loader-module--spin--1y6se";